import { channelPartnerRequestQueryKeys as e } from "./useChannelPartnerRequestQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminChannelPartnerRequestsApi as n } from "@maat/api-main";
//#region src/channelPartnerRequests/useChannelPartnerRequestStatsQuery.ts
var r = (r = {}, i = !0) => t({
	queryKey: e.stats(r),
	queryFn: () => n.stats(r),
	enabled: i
});
//#endregion
export { r as useChannelPartnerRequestStatsQuery };
